var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-8",attrs:{"id":"html-input"}},[(_vm.label)?_c('h2',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("toolbar"),_c('div',{ref:"quillField",attrs:{"name":"input"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }